module.exports = __webpack_public_path__ + "aea0057cd0e49213aacf91d2b3fd6b28.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-14.png
// module id = 2591
// module chunks = 0